export enum BREAKPOINT {
  XS = 490,
  SM = 768,
  MD = 1040,
  LG = 1800,
  XL = 1920,
}

export enum Subscription {
  Monthly = 'monthly',
  Annually = 'yearly',
  Lifetime = 'lifetime',
}

export enum Plan {
  FREE = 'free',
  CHARGE = 'charge',
  STANDARD = 'standard',
  PRO = 'pro',
  SHOPIFY_PLUS = 'plus',
}

export enum ShopifyPlan {
  PLUS = 'shopify_plus',
  PARTNER_TEST = 'partner_test',
  PARTNER_SANDBOX = 'plus_partner_sandbox',
}

export enum Rules {
  Methods = 1,
  PostCode = 2,
  Country = 3,
}

export enum TargetTypes {
  Product = 'product',
  Collection = 'collection',
  Vendor = 'vendor',
}

export enum DeliveryMethodLayout {
  Card = 'card',
  Select = 'select',
}

export enum TimeCountDownFormat {
  Full = 1,
  DayHourMinute = 2,
  DayHour = 3,
  HourMinuteSecond = 4,
  HourMinute = 5,
}

export enum CountdownTimerOption {
  NextCutoff = 'next_cutoff',
  EndOfDay = 'end_of_day',
}

export enum PositionCode {
  UnderProductDescription = 1,
  UnderAtcButton = 2,
  UnderProductPrice = 3,
  UnderProductTitle = 4,
}

export enum RenderMethod {
  After = 'after',
  Before = 'before',
  Prepend = 'prepend',
}
export enum ScopePostCode {
  AllProduct = 1,
  Vendors = 2,
  Collections = 3,
  Products = 0,
}

export enum DateRangeDirection {
  Vertical = 'column',
  Horizontal = 'row',
}

export enum DateRangeIcon {
  Arrow = '→',
  Dash = '-',
}

export enum EnableApp {
  Active = 1,
  InActive = 0,
}

export enum EnableTimelineLayout {
  Active = 1,
  InActive = 0,
}
export enum EnableETAInformationLayout {
  Active = 1,
  InActive = 0,
}

export enum ShowTimeOnCart {
  Active = 1,
  InActive = 0,
}

export enum ShowOnLineItem {
  Active = 1,
  InActive = 0,
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum Ga4Event {
  PricingPlanImpression = 'pricing_plan_impression',
  ChoosePlan = 'choose_plan',
  ChargeDone = 'charge_done',
  Uninstall = 'uninstall',
  SynctrackImpression = 'impress_ST',
  SynctrackClick = 'click_ST',
  BlockifyImpression = 'impress_checkout',
  BlockifyClick = 'click_checkout',
  OrderTrackingImpression = 'impress_homebanner3',
  OrderTrackingClick = 'click_homebanner3',
  ReturnsImpression = 'impress_returns',
  ReturnsClick = 'click_returns',
  ParetoImpression = 'impress_limit',
  ParetoClick = 'click_limit',
}

export enum QuickTemplateType {
  Basic = 'basic',
  Advanced = 'advanced',
  Blank = 'blank',
}

export enum TypePreference {
  Method = 'delivery',
  PostCode = 'postal',
  Country = 'country',
}

export enum OnboardingTrackingStep {
  Step1 = 1,
  Step2 = 2,
  Step3 = 3,
  Step4 = 4,
  Step5 = 5,
  Finish = 6,
}

export enum DateDisplayMode {
  Relative = 'relative',
  Absolute = 'absolute',
}

export enum CartDateDisplayType {
  MessageText = 'message_text',
  CustomizeText = 'customize_text',
}

export enum KeysUpdateMultipleRule {
  ShowInCart = 'show_text_in_cart',
  Enable = 'enable',
  Shop = 'shop',
}

export enum AppliedItemTypes {
  All = 0,
  Include = 1,
  Exclude = 2,
}

export enum TemplateColors {
  CLEAR = 'clear',
  WHITE = 'white',
  SILVER = 'silver',
  SLATE = 'slate',
  INDIGO = 'indigo',
  PURPLE = 'purple',
  CYAN = 'cyan',
  TEAL = 'teal',
  MINT = 'mint',
  LIME = 'lime',
  YELLOW = 'yellow',
  ORANGE = 'orange',
  SKY = 'sky',
  PINK = 'pink',
  RED = 'red',
  LATTE = 'latte',
}

export enum TimelineIconsEnum {
  Order = 1,
  Prepare = 2,
  Delivery = 3,
  Location = 4,
}

export enum TimelineIconStages {
  Stage1 = 'timelineOrderIcon',
  Stage2 = 'timelineShipIcon',
  Stage3 = 'timelineDeliveryIcon',
}

export enum NumberTimelineIconStages {
  timelineOrderIcon = 1,
  timelineShipIcon = 2,
  timelineDeliveryIcon = 3,
}

export enum EmojiIconId {
  Time1 = 0,
  Time2 = 1,
  Time3 = 2,
  Time4 = 3,
  Time5 = 4,
  Time6 = 5,
  Time7 = 6,
  Time8 = 7,
  Time9 = 8,
  Time10 = 9,
  Time11 = 10,
  Time12 = 11,
  Time13 = 12,
  Time14 = 13,
  Time15 = 14,
  Deal1 = 15,
  Deal2 = 16,
  Deal3 = 17,
  Deal4 = 18,
  Deal5 = 19,
  Deal6 = 20,
  Deal7 = 21,
  Deal8 = 22,
  Deal9 = 23,
  Deal10 = 24,
  Deal11 = 25,
  Deal12 = 26,
  Order1 = 27,
  Order2 = 28,
  Order3 = 29,
  Order4 = 30,
  Order5 = 31,
  Order6 = 32,
  Order7 = 33,
  Order8 = 34,
  Order9 = 35,
  Order10 = 36,
  Order11 = 37,
  Order12 = 38,
  Order13 = 39,
  Order14 = 72,
  Order15 = 73,
  Order16 = 74,
  Order17 = 75,
  Order18 = 76,
  Order19 = 77,
  Order20 = 78,
  Order21 = 79,
  Prepare1 = 40,
  Prepare2 = 41,
  Prepare3 = 42,
  Prepare4 = 43,
  Prepare5 = 44,
  Prepare6 = 45,
  Prepare7 = 46,
  Prepare8 = 47,
  Prepare9 = 80,
  Prepare10 = 81,
  Prepare11 = 82,
  Prepare12 = 83,
  Prepare13 = 84,
  Prepare14 = 85,
  Prepare15 = 86,
  Prepare16 = 87,
  Prepare17 = 88,
  Prepare18 = 89,
  Delivery1 = 48,
  Delivery2 = 49,
  Delivery3 = 50,
  Delivery4 = 51,
  Delivery5 = 52,
  Delivery6 = 53,
  Delivery7 = 54,
  Delivery8 = 55,
  Delivery9 = 56,
  Delivery10 = 57,
  Delivery11 = 58,
  Delivery12 = 90,
  Delivery13 = 91,
  Delivery14 = 92,
  Delivery15 = 93,
  Delivery16 = 94,
  Delivery17 = 95,
  Delivery18 = 96,
  Delivery19 = 97,
  Delivery20 = 98,
  Delivery21 = 99,
  Location1 = 59,
  Location2 = 60,
  Location3 = 61,
  Location4 = 62,
  Location5 = 63,
  Location6 = 64,
  Location7 = 65,
  Location8 = 66,
  Location9 = 67,
  Location10 = 68,
  Location11 = 69,
  Location12 = 70,
  Location13 = 71,
  Location14 = 100,
  Location15 = 101,
  Location16 = 102,
  Location17 = 103,
  Location18 = 104,
  Location19 = 105,
  Location20 = 106,
  Location21 = 107,
}

export enum TimeLineIconId {
  Order1 = 0,
  Order2 = 1,
  Order3 = 2,
  Order4 = 3,
  Order5 = 4,
  Order6 = 5,
  Order7 = 6,
  Order8 = 7,
  Order9 = 8,
  Order10 = 9,
  Order11 = 10,
  Order12 = 11,
  Order13 = 12,
  Order14 = 13,
  Order15 = 14,
  Order16 = 15,
  Order17 = 16,
  Order18 = 17,
  Order19 = 18,
  Order20 = 19,
  Order21 = 20,
  Order22 = 21,
  Prepare1 = 22,
  Prepare2 = 23,
  Prepare3 = 24,
  Prepare4 = 25,
  Prepare5 = 26,
  Prepare6 = 27,
  Prepare7 = 28,
  Prepare8 = 29,
  Prepare9 = 30,
  Prepare10 = 31,
  Prepare11 = 32,
  Prepare12 = 33,
  Prepare13 = 34,
  Prepare14 = 35,
  Prepare15 = 36,
  Prepare16 = 37,
  Prepare17 = 38,
  Prepare18 = 39,
  Prepare19 = 40,
  Prepare20 = 41,
  Prepare21 = 42,
  Prepare22 = 43,
  Delivery1 = 44,
  Delivery2 = 45,
  Delivery3 = 46,
  Delivery4 = 47,
  Delivery5 = 48,
  Delivery6 = 49,
  Delivery7 = 50,
  Delivery8 = 51,
  Delivery9 = 52,
  Delivery10 = 53,
  Delivery11 = 54,
  Delivery12 = 55,
  Delivery13 = 56,
  Delivery14 = 57,
  Delivery15 = 58,
  Delivery16 = 59,
  Delivery17 = 60,
  Delivery18 = 61,
  Delivery19 = 62,
  Delivery20 = 63,
  Delivery21 = 64,
  Delivery22 = 65,
  Delivery23 = 66,
  Location1 = 67,
  Location2 = 68,
  Location3 = 69,
  Location4 = 70,
  Location5 = 71,
  Location6 = 72,
  Location7 = 73,
  Location8 = 74,
  Location9 = 75,
  Location10 = 76,
  Location11 = 77,
  Location12 = 78,
  Location13 = 79,
  Location14 = 80,
  Location15 = 81,
  Location16 = 82,
  Location17 = 83,
  Location18 = 84,
  Location19 = 85,
  Location20 = 86,
  Location21 = 87,
}

export enum UnionCountry {
  '*' = 'All',
  'restOfWorld' = 'Rest of the World',
  'NorthAmerica' = 'North America',
  'SouthAmerica' = 'South America',
  'EU' = 'European Union',
  'SEA' = 'Southeast Asia',
  'EastAsia' = 'East Asia',
  'SouthAsia' = 'South Asia',
  'WestAsia' = 'West Asia',
}

export enum TextSize {
  extraSmall = 'Xsmall',
  small = 'Small',
  medium = 'Medium',
  large = 'Large',
  extraLarge = 'Xlarge',
  base = 'Base',
}

export enum TextSizeKeys {
  extraSmall = 'extraSmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
  extraLarge = 'extraLarge',
  base = 'base',
}

export enum TextAppearance {
  base = 'Base',
  subdue = 'Subdue',
  accent = 'Accent',
  critical = 'Critical',
  info = 'Info',
  warning = 'Warning',
  success = 'Success',
  decorative = 'Decorative',
}

export enum TextAppearanceKeys {
  base = 'base',
  subdue = 'subdued',
  accent = 'accent',
  critical = 'critical',
  info = 'info',
  warning = 'warning',
  success = 'success',
  decorative = 'decorative',
}

export enum TextEmphasis {
  base = 'Base',
  bold = 'Bold',
  italic = 'Italic',
}

export enum TextEmphasisKeys {
  base = 'base',
  bold = 'bold',
  italic = 'italic',
}

export enum PrefixIcon {
  none = 0,
  truck = 1,
  delivered = 2,
  store = 3,
  calendar = 4,
  clock = 5,
  bag = 6,
  cart = 7,
  delivery = 8,
  gift = 9,
  marker = 10,
  geolocation = 11,
  info = 12,
  critical = 13,
  warning = 14,
  success = 15,
  checkmark = 16,
}

export enum PrefixIconSize {
  base = 'Base',
  extraSmall = 'XSmall',
  small = 'Small',
  large = 'Large',
}

export enum PrefixIconSizeKeys {
  base = 'base',
  extraSmall = 'extraSmall',
  small = 'small',
  large = 'large',
}

export enum PrefixIconColor {
  base = 'Base',
  accent = 'Accent',
  decorative = 'Deco',
  critical = 'Critical',
  warning = 'Warning',
  info = 'Info',
  interactive = 'Interact',
  monochrome = 'Mono',
  subdued = 'Subdue',
  success = 'Success',
}

export enum PrefixIconColorKeys {
  base = 'base',
  accent = 'accent',
  critical = 'critical',
  decorative = 'decorative',
  info = 'info',
  interactive = 'interactive',
  monochrome = 'monochrome',
  subdued = 'subdued',
  success = 'success',
  warning = 'warning',
}

export enum ThankyouDisplayModes {
  banner = 'banner',
  plain = 'plainText',
}

export enum BannerStatus {
  info = 'info',
  warning = 'warning',
  success = 'success',
  critical = 'critical',
}

export enum Touchpoint {
  PricingPlan = 'pricing_plan',
  HomeTopBanner = 'home_top_banner',
  ChecklistGeneralRuleLimit = 'checklist_general_rule_limit',
  ChecklistShowInCart = 'checklist_show_in_cart',
  ChecklistSpecificRuleLimit = 'checklist_specific_rule_limit',
  ChecklistAutoDetectLocation = 'checklist_auto_detect_location',
  SettingsTopBanner = 'settings_top_banner',
  SetupZipcodeLimit = 'setup_zipcode_limit',
  SetupCountryLimit = 'setup_country_limit',
  SetupStateRule = 'setup_state_rule',
  SetupAdditionalTopBanner = 'setup_additional_top_banner',
  SetupAppliedItems = 'setup_applied_items',
  SetupShowInCart = 'setup_show_in_cart',
  SetupSpecificRuleItemLimit = 'setup_specific_rule_item_limit',
  SetupSpecificAdditionalTopBanner = 'setup_specific_additional_top_banner',
  SetupSpecificShowInCart = 'setup_specific_show_in_cart',
  AppearanceChangeIcon = 'appearance_change_icon',
  AppearanceVisualEditor = 'appearance_visual_editor',
  CustomCSS = 'custom_css',
  SetupOutOfStock = 'setup_out_of_stock',
  UpgradeETACheckout = 'upgrade_ETA_checkout',
}

export enum HighlightContentPreviewId {
  TimelineOrderStepDescription = 'ot-timeline-order-step-description',
  TimelineShipStepDescription = 'ot-timeline-ship-step-description',
  TimelineDeliveryStepDescription = 'ot-timeline-delivery-step-description',
  TimelineOrderStepTitle = 'ot-timeline-order-step-title',
  TimelineShipStepTitle = 'ot-timeline-ship-step-title',
  TimelineDeliveryStepTitle = 'ot-timeline-delivery-step-title',
  AppearanceTextColor = 'ot-appearance-text-color',
  AppearanceBackgroundColor = 'ot-appearance-background-color',
  AppearanceTimelineIconColor = 'ot-appearance-timeline-icon-color',
  AppearanceBorderColor = 'ot-appearance-border-color',
  DateFormat = 'ot-date-format',
  DateRangeIcon = 'ot-date-range-icon',
  DateRangeIconSetup = 'ot-date-range-icon-setup',
  ZipcodeCheckerLabel = 'ot-zipcode-checker-label',
  ZipcodeValidText = 'ot-zipcode-valid-text',
  ZipcodeInvalidText = 'ot-zipcode-invalid-text',
  ShippingMethodHeader = 'ot-shipping-method-header',
}

export enum ItemConditionEnum {
  IncludeProduct = 'products_applied',
  ExcludeProduct = 'products_excluded',
  IncludeCollection = 'collections_applied',
  ExcludeCollection = 'collections_excluded',
  IncludeVendor = 'vendors_applied',
  ExcludeVendor = 'vendors_excluded',
  ExcludeProductTag = 'tags_excluded',
  IncludeProductTag = 'tags_applied',
  IncludeSKU = 'skus_applied',
  ExcludeSKU = 'skus_excluded',
  Exception = 'products_exception',
  InventoryQuantity = 'inventory_quantity',
  // ExcludeInventoryLocation = 'inventory_locations_excluded',
  // IncludeInventoryLocation = 'inventory_locations_applied',
  // IncludeProductMetafield = 'metafields_products_applied',
  // ExcludeProductMetafield = 'metafields_products_excluded',
  // IncludeVariantMetafield = 'metafields_variants_applied',
  // ExcludeVariantMetafield = 'metafields_variants_excluded',
}

export enum LocationConditionEnum {
  Country = 'country',
  State = 'state',
  Zipcode = 'zipcode',
  City = 'city',
}

export enum EstElementId {
  SaveBar = 'setting-save-bar',
  ModalLanguage = 'modal-language',
}

export enum ClassEnum {
  Main = 'ot-estimated-shipping',
}

export enum ShippingRuleClassEnum {
  ShippingRuleContainer = `${ClassEnum.Main}-shipping-methods`,
  ShippingRuleItem = `${ClassEnum.Main}-item-shipping-method`,
  ShippingSelectBox = `${ClassEnum.Main}-shipping-methods-select-box`,
  ShippingCardItem = `${ClassEnum.Main}-shipping-methods-select-item`,
  ShippingCardRadio = `${ClassEnum.Main}-item-radio`,
  ShippingCardTitle = `${ClassEnum.Main}-title-shipping`,
  ShippingCardText = `${ClassEnum.Main}-text-shipping`,
  ShippingCardName = `${ClassEnum.Main}-name-shipping`,
  ShippingPrivacyContainer = `${ClassEnum.Main}-basic-shipping-privacy`,
  ShippingPrivacyLink = 'shipping-privacy-href',
  ShippingPrivacyContent = `${ClassEnum.Main}-basic-shipping-privacy-text`,
  ShippingPrivacyMore = `${ClassEnum.Main}-basic-shipping-privacy-more`,
  ShippingPrivacyMorePopup = `${ClassEnum.Main}-basic-shipping-privacy-more-popup`,
}

export enum DynamicDateInCartEnum {
  Dynamic = 'dynamic',
  Static = 'static',
}

export enum CutOffTimeTypes {
  PrepareAndDelivery = 'prepareAndDelivery',
  Prepare = 'prepare',
  Delivery = 'delivery',
}

export enum CountryCode {
  'ad' = 'ad',
  'ae' = 'ae',
  'af' = 'af',
  'ag' = 'ag',
  'ai' = 'ai',
  'al' = 'al',
  'am' = 'am',
  'ao' = 'ao',
  'ar' = 'ar',
  'as' = 'as',
  'at' = 'austrian',
  'au' = 'australian',
  'aw' = 'aw',
  'az' = 'az',
  'ba' = 'ba',
  'bb' = 'bb',
  'bd' = 'bd',
  'be' = 'be',
  'bf' = 'bf',
  'bg' = 'bulgarian',
  'bh' = 'bh',
  'bi' = 'bi',
  'bj' = 'bj',
  'bl' = 'bl',
  'bm' = 'bm',
  'bn' = 'bn',
  'bo' = 'bo',
  'br' = 'brazilian',
  'bs' = 'bs',
  'bt' = 'bt',
  'bw' = 'bw',
  'by' = 'by',
  'bz' = 'bz',
  'ca' = 'canadian',
  'cd' = 'cd',
  'cf' = 'cf',
  'cg' = 'cg',
  'ch' = 'ch',
  'ci' = 'ci',
  'ck' = 'ck',
  'cl' = 'cl',
  'cm' = 'cm',
  'cn' = 'china',
  'co' = 'co',
  'cr' = 'cr',
  'cu' = 'cu',
  'cv' = 'cv',
  'cw' = 'cw',
  'cy' = 'cy',
  'cz' = 'czech',
  'de' = 'german',
  'dj' = 'dj',
  'dk' = 'danish',
  'dm' = 'dm',
  'do' = 'do',
  'dz' = 'dz',
  'ec' = 'ec',
  'ee' = 'ee',
  'eg' = 'eg',
  'er' = 'er',
  'es' = 'spain',
  'et' = 'et',
  'fi' = 'finnish',
  'fj' = 'fj',
  'fk' = 'fk',
  'fm' = 'fm',
  'fo' = 'fo',
  'fr' = 'french',
  'ga' = 'ga',
  'gb' = 'uk',
  'gd' = 'gd',
  'ge' = 'ge',
  'gf' = 'gf',
  'gg' = 'gg',
  'gh' = 'gh',
  'gi' = 'gi',
  'gl' = 'gl',
  'gm' = 'gm',
  'gn' = 'gn',
  'gp' = 'gp',
  'gq' = 'gq',
  'gr' = 'greek',
  'gt' = 'gt',
  'gu' = 'gu',
  'gw' = 'gw',
  'gy' = 'gy',
  'hk' = 'hong_kong',
  'hn' = 'hn',
  'hr' = 'croatian',
  'ht' = 'ht',
  'hu' = 'hungarian',
  'id' = 'indonesian',
  'ie' = 'irish',
  'il' = 'jewish',
  'im' = 'im',
  'in' = 'indian',
  'iq' = 'iq',
  'ir' = 'ir',
  'is' = 'is',
  'it' = 'italian',
  'je' = 'je',
  'jm' = 'jm',
  'jo' = 'jo',
  'jp' = 'japanese',
  'ke' = 'ke',
  'kg' = 'kg',
  'kh' = 'kh',
  'ki' = 'ki',
  'km' = 'km',
  'kn' = 'kn',
  'kp' = 'kp',
  'kr' = 'south_korea',
  'kw' = 'kw',
  'ky' = 'ky',
  'kz' = 'kz',
  'la' = 'la',
  'lb' = 'lb',
  'lc' = 'lc',
  'li' = 'li',
  'lk' = 'lk',
  'lr' = 'lr',
  'ls' = 'ls',
  'lt' = 'lithuanian',
  'lu' = 'lu',
  'lv' = 'latvian',
  'ly' = 'ly',
  'ma' = 'ma',
  'mc' = 'mc',
  'md' = 'md',
  'me' = 'me',
  'mf' = 'mf',
  'mg' = 'mg',
  'mh' = 'mh',
  'mk' = 'mk',
  'ml' = 'ml',
  'mm' = 'mm',
  'mn' = 'mn',
  'mo' = 'mo',
  'mp' = 'mp',
  'mq' = 'mq',
  'mr' = 'mr',
  'ms' = 'ms',
  'mt' = 'mt',
  'mu' = 'mu',
  'mv' = 'mv',
  'mw' = 'mw',
  'mx' = 'mexican',
  'my' = 'malaysia',
  'mz' = 'mz',
  'na' = 'na',
  'nc' = 'nc',
  'ne' = 'ne',
  'ng' = 'ng',
  'ni' = 'ni',
  'nl' = 'dutch',
  'no' = 'norwegian',
  'np' = 'np',
  'nr' = 'nr',
  'nz' = 'new_zealand',
  'om' = 'om',
  'pa' = 'pa',
  'pe' = 'pe',
  'pf' = 'pf',
  'pg' = 'pg',
  'ph' = 'philippines',
  'pk' = 'pk',
  'pl' = 'polish',
  'pm' = 'pm',
  'pr' = 'pr',
  'pt' = 'portuguese',
  'pw' = 'pw',
  'py' = 'py',
  'qa' = 'qa',
  're' = 're',
  'ro' = 'romanian',
  'rs' = 'rs',
  'ru' = 'russian',
  'rw' = 'rw',
  'sa' = 'saudiarabian',
  'sb' = 'sb',
  'sc' = 'sc',
  'sd' = 'sd',
  'se' = 'swedish',
  'sg' = 'singapore',
  'sh' = 'sh',
  'si' = 'slovenian',
  'sk' = 'slovak',
  'sl' = 'sl',
  'sm' = 'sm',
  'sn' = 'sn',
  'so' = 'so',
  'sr' = 'sr',
  'ss' = 'ss',
  'st' = 'st',
  'sv' = 'sv',
  'sx' = 'sx',
  'sy' = 'sy',
  'sz' = 'sz',
  'tc' = 'tc',
  'td' = 'td',
  'tg' = 'tg',
  'th' = 'th',
  'tj' = 'tj',
  'tl' = 'tl',
  'tm' = 'tm',
  'tn' = 'tn',
  'to' = 'to',
  'tr' = 'turkish',
  'tt' = 'tt',
  'tv' = 'tv',
  'tw' = 'taiwan',
  'tz' = 'tz',
  'ua' = 'ukrainian',
  'ug' = 'ug',
  'us' = 'usa',
  'uy' = 'uy',
  'uz' = 'uz',
  'va' = 'va',
  'vc' = 'vc',
  've' = 've',
  'vg' = 'vg',
  'vi' = 'vi',
  'vn' = 'vietnamese',
  'vu' = 'vu',
  'wf' = 'wf',
  'ws' = 'ws',
  'xk' = 'xk',
  'ye' = 'ye',
  'yt' = 'yt',
  'za' = 'sa',
  'zm' = 'zm',
  'zw' = 'zw',
}

export enum SortOptionsEnum {
  IdDesc = 'id_desc',
  IdAsc = 'id_asc',
  NameDesc = 'name_desc',
  NameAsc = 'name_asc',
  MinPrepareDesc = 'min_prepare_desc',
  MinPrepareAsc = 'min_prepare_asc',
  MaxPrepareDesc = 'max_prepare_desc',
  MaxPrepareAsc = 'max_prepare_asc',
  MinDeliveryDesc = 'min_delivery_desc',
  MinDeliveryAsc = 'min_delivery_asc',
  MaxDeliveryDesc = 'max_delivery_desc',
  MaxDeliveryAsc = 'max_delivery_asc',
}

export enum ScopeEnum {
  ReadLocales = 'read_locales',
  ReadInventory = 'read_inventory',
}

export enum DataCalculationMethodEnum {
  OrderDate = 'orderDate',
  MaxPreparationDate = 'maxPreparationDate',
}

export enum MetafieldType {
  Text = 'text',
  Decimal = 'decimal',
  Integer = 'integer',
}

export enum MetafieldNumericValuePrefix {
  Min = 'min: ',
  Max = 'max: ',
}

export enum CountdownMethodEnum {
  UntilCutoff = 'until_cutoff',
  FixedDuration = 'fixed_duration',
  SpecificDatetime = 'specific_datetime',
}

export enum SessionBehaviorEnum {
  RestartEachSession = 'restart_each_session',
  CountUntilFinished = 'count_until_finished',
}

export enum EndBehaviorEnum {
  Hide = 'hide',
  RestartImmediately = 'restart_immediately',
}

export enum DisplayModeEnum {
  AllTime = 'ALL_TIME',
  SpecificDays = 'SPECIFIC_DAYS',
  DateRange = 'DATE_RANGE',
}

export enum CrispSegmentEnum {
  VIPCustomers = 'VIP customers',
  PremiumCustomers = 'Premium customers',
  NewCustomers = 'New customers',
}
export enum AppKeyEnum {
  Return = 'return',
  PaypalTracking = 'paypal_tracking',
  OrderTracking = 'order_tracking',
  LlmIndex = 'llm_index',
  DingDoong = 'ding_doong',
  Estimated = 'estimated',
  Floatify = 'floatify',
  ChatForm = 'chat_form',
  BlockifyFraud = 'blockify_fraud',
  BlockifyCheckoutRules = 'blockify_checkout_rules',
  BlockifyAgeVerification = 'blockify_age_verification',
  BlockifyRecordReplay = 'blockify_record_replay',
}
export enum PlatformEnum {
  Shopify = 'shopify',
  Wix = 'wix',
  Woo = 'woo',
  Shopline = 'shopline',
}
export enum BannerToneEnum {
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Critical = 'critical',
}
